module.exports = __webpack_public_path__ + "img/product-beats-2.295a0994.png";